import type { TSparseOrganization } from '@modules/users/types/organizations.types';

export const isChangeTemplatesEnabled = (organization: Pick<TSparseOrganization, 'featureSettings' | 'folders'>) =>
  // The backend rejects every route without the flag.
  !!organization.featureSettings.changes?.enabled &&
  // The pages need both folder references.
  !!organization.folders.changeTemplates &&
  !!organization.folders.qm;
